'use client';
import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

export default function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-6 py-4 flex items-center justify-between"
      style={{ background: 'linear-gradient(to bottom, rgba(9,9,11,0.95) 0%, rgba(9,9,11,0) 100%)' }}>
      <AppLogo
        text="Basecamp"
        iconName="CircleStackIcon"
        size={28}
        className="text-fg font-mono font-semibold tracking-tight"
      />
      <nav className="hidden md:flex items-center gap-6">
        {['Scripting', 'Automations', 'Integrations', 'Schema'].map((item) => (
          <a
            key={item}
            href={`#${item.toLowerCase()}`}
            className="text-fg-muted hover:text-lilac transition-colors duration-200 text-sm font-medium font-mono"
          >
            {item}
          </a>
        ))}
      </nav>
      <a
        href="#download"
        className="hidden md:flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all duration-200"
        style={{ background: 'rgba(124, 58, 237, 0.15)', border: '1px solid rgba(124, 58, 237, 0.4)', color: '#C4B5FD' }}
        onMouseEnter={e => {
          (e.currentTarget as HTMLElement).style.background = 'rgba(124, 58, 237, 0.3)';
          (e.currentTarget as HTMLElement).style.borderColor = 'rgba(124, 58, 237, 0.8)';
        }}
        onMouseLeave={e => {
          (e.currentTarget as HTMLElement).style.background = 'rgba(124, 58, 237, 0.15)';
          (e.currentTarget as HTMLElement).style.borderColor = 'rgba(124, 58, 237, 0.4)';
        }}
      >
        <span>Download Reader</span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M6 1v7M3 5l3 3 3-3M1 10h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </a>
    </header>
  );
}